import type { QSetSimilarityResultData, QSetSimilarityResultRowArray } from '../../types';
import { getQSetRunningNumber } from '../get-qset-running-number';

export default function generateDraftToPublishedData(
  data: QSetSimilarityResultData[],
  uniqueQSetCodes: {
    drafts: string[];
    published: string[];
  },
): [string[], QSetSimilarityResultRowArray[]] {
  const uniqueCodes = Array.from(
    new Set(data.map(({ qSetACode, qSetBCode }) => [qSetACode, qSetBCode]).flat()),
  );
  const columns = uniqueCodes.filter((code) =>
    uniqueQSetCodes.published.find((qSetCode) => qSetCode === code),
  );
  columns.sort((a, b) => {
    const numA = parseInt(a.replace(/\D/g, ''), 10);
    const numB = parseInt(b.replace(/\D/g, ''), 10);
    return numA - numB;
  });

  const rowsHeaders = uniqueCodes.filter((code) =>
    uniqueQSetCodes.drafts.find((qSetCode) => qSetCode === code),
  );
  rowsHeaders.sort((a, b) => {
    const numA = parseInt(a.replace(/\D/g, ''), 10);
    const numB = parseInt(b.replace(/\D/g, ''), 10);
    return numA - numB;
  });

  const rows: QSetSimilarityResultRowArray[] = [];
  for (let i = 0; i < rowsHeaders.length; i++) {
    rows.push([getQSetRunningNumber(rowsHeaders[i])]);
    for (let j = 0; j < columns.length; j++) {
      const found = data.find(
        ({ qSetACode, qSetBCode }) =>
          (qSetACode === rowsHeaders[i] && qSetBCode === columns[j]) ||
          (qSetACode === columns[j] && qSetBCode === rowsHeaders[i]),
      );
      rows[i].push(found?.duplicationRate ?? null);
    }
  }
  return [columns.map(getQSetRunningNumber), rows];
}
